import React from "react";
import { connect } from "react-redux";
import Floorplans from "../Specials/Floorplans/Floorplan.Carousel";
import Appointments from "../Specials/Appointments/Appointment.Carousel";
import Iframe from "../Specials/Iframe.Specials";
import Gallery from "../Specials/Gallery/Gallery.Carousel";
import UnitMap from "../Specials/UnitMap/UnitMap.Carousel";
import Map from "../Specials/Map/Map.Specials";
import Multibot from "../Specials/Multibot.Specials";
import ReviewList from "../Specials/Review.Specials";
import ReviewCarousel from "../Specials/ReviewRatings/Review.Carousel";
import styled from "styled-components";
import Contacts from "../Specials/Contacts/Contacts.List";

const components = {
  floorplan: Floorplans,
  date: Appointments,
  virtual: Iframe,
  gallery: Gallery,
  contacts: Contacts,
  unitmap: UnitMap,
  map: Map,
  multibot: Multibot,
  review: ReviewList,
  reviewcarousel: ReviewCarousel,
};

const SpecialsWrapper = styled.div`
  position: relative;
  ${(props) => (props.type === "unitmap" ? "" : `margin-top: 17px;`)}

  ${({type}) => type === 'date' && `padding: 0; margin-top: 34px;`}

  ${({ type }) =>
    type !== "floorplan" &&
    type !== "multibot" &&
    type !== "unitmap" &&
    type !== "date" &&
    `padding: 0 68px;`};

  ${({ type }) =>
    type === "map" &&
    `
    padding: 0 22px;
  `};

  ${({ type }) => type === "virtual" && `padding: 0 22px;`};

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakXsmall}) {
    ${(props) => props.type === "gallery" && `padding: 0 23px;`}
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    ${({ type }) =>
      type !== "floorplan" &&
      type !== "multibot" &&
      type !== "multibot" &&
      type != "unitmap" &&
      `padding: 0 80px 0 107px;`};
    ${({ type }) => type === "date" && `padding: 0; margin-top: 44px;`};
    ${({ type }) => type === "multibot" && `padding-left: 26px;`};
    ${({ type }) =>
      (type === "virtual" || type === "map" || type === "gallery") &&
      `padding: 0 30px;`};
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    ${({ type }) =>
      type !== "floorplan" && type != "unitmap" && `padding: 0 200px;`};
    ${({ type }) =>
      (type === "map" || type === "gallery" || type === "virtual") &&
      `padding: 0 182px 0 200px;`};
    ${({type}) => type === 'date' && `padding: 0; margin-top: 34px;`}  
  }
`;

function List({ specials }) {

  const SpecialType = components[specials.type];

  if (!specials || (specials.list && specials.list.length <= 0)) {
    return <></>;
  }

  return (
    <SpecialsWrapper className="SpecialsWrapper" type={specials.type}>
      {specials.type && (
        <SpecialType
          className={`SpecialType-${specials.type}`}
          data={specials.list}
        />
      )}
    </SpecialsWrapper>
  );
}

const mapStateToProps = (state) => ({
  specials: state.chat.specials,
});

export default connect(mapStateToProps)(List);
